"use strict";

exports.__esModule = true;
exports.HTMLElement = void 0;
// Polyfills for SSR
var isSSR = typeof window === 'undefined';
var HTMLElement = isSSR ? Object : window.HTMLElement;
exports.HTMLElement = HTMLElement;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/ssr.js
// module id = 1263
// module chunks = 0